module.exports = [{"type":"title","text":"2025-10-09"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"BingX Fully Releases Spot Account Function:https://bingx.com/en/support/articles/13672873913359"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-10-09.json
// module id = AxcT
// module chunks = 3